
import { Helmet } from 'react-helmet-async';
import { TeamSection } from '@/components/about/TeamSection';
import { InvestorsSection } from '@/components/about/InvestorsSection';
import { AdvisorsSection } from '@/components/about/AdvisorsSection';
import { PageHeader } from '@/components/about/PageHeader';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>About Us | Meet the Cutshort Team</title>
        <meta name="description" content="Meet the team behind Cutshort - leaders, innovators, and experts dedicated to transforming tech hiring in India." />
        <meta property="og:title" content="About Us | Meet the Cutshort Team" />
        <meta property="og:description" content="Meet the team behind Cutshort - leaders, innovators, and experts dedicated to transforming tech hiring in India." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us | Meet the Cutshort Team" />
        <meta name="twitter:description" content="Meet the team behind Cutshort - leaders, innovators, and experts dedicated to transforming tech hiring in India." />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <PageHeader />
        <TeamSection />
        <InvestorsSection />
        <AdvisorsSection />
      </div>
    </div>
  );
};

export default About;
